import "@fontsource-variable/inter/index.css";
import "@/app/assets/styles/index.sass";
import ReactDOM from "react-dom/client";
import App from "./app";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
